// 各页面的 SEO 信息、服务落地页内容、客户案例（纯数据）

// 客户案例：只放真实项目，内容由牧色提供；数组为空时首页不显示该区块
// 结构：{ tag: '量化做市商', zh: { client, problem, did, result }, en: { ... } }
export const CASES = [
  {
    zh: {
      tag: '量化做市商',
      client: '某量化交易做市商',
      problem: '生产服务器遭黑客入侵，需要尽快止损，并防止再次被攻破。',
      did: '部署 CrowdStrike Falcon 终端防护，并按客户业务调整检测与拦截策略后上线；为生产内网搭建零信任访问，内部系统统一通过零信任访问，不对公网开放。',
      result: '持续服务一年多，期间未发生任何资金损失事件。',
    },
    en: {
      tag: 'QUANT MARKET MAKER',
      client: 'A quantitative trading market maker',
      problem: 'Production servers were breached by attackers; the client needed to contain the incident and prevent another compromise.',
      did: "Deployed CrowdStrike Falcon endpoint protection with detection and prevention policies tuned to the client's workloads, and put the production network and internal systems behind zero-trust access instead of direct exposure.",
      result: 'More than a year of ongoing service with no fund-loss incidents.',
    },
  },
]

export const HOME_META = {
  zh: {
    title: '牧色安全 Musesec｜区块链企业资产安全 · 链上 + 链下一体化防护',
    description: '没有安全团队？我们来当你的安全团队。为区块链创业公司提供交易所级别的资产保护：员工电脑、服务器、钱包与签名流程、智能合约、值班与应急响应。',
  },
  en: {
    title: 'Musesec | Web3 Security for Startups — On-chain + Off-chain Protection',
    description: 'No security team? We become your security team. Exchange-grade asset protection for blockchain startups: devices, servers, wallets and signing, smart contracts, 24/7 incident response.',
  },
}

export const SERVICES = [
  {
    slug: 'security-assessment',
    zh: {
      nav: '资产安全体检',
      metaTitle: '区块链企业资产安全体检｜找出资金最可能丢失的地方 - 牧色安全',
      metaDesc: '2–3 周完成区块链公司资产安全体检：员工电脑、服务器、钱包与签名流程、第三方依赖逐项检查，输出按优先级排序的整改清单。¥3 万起。',
      eyebrow: '资产安全体检',
      title: '2–3 周，找出你的钱最可能从哪里丢',
      sub: '检查范围覆盖员工电脑、服务器、钱包和签名流程、第三方工具，交付一份按优先级排好、可直接执行的整改清单。',
      who: ['还没有专职安全负责人的区块链创业团队', '准备上线、融资或接入交易所，需要先摸清风险', '刚经历过可疑事件，想知道还有没有隐患'],
      get: ['关键人员访谈：谁能动钱、怎么动、出了事找谁', '电脑、账号、服务器、云配置检查', '钱包架构、多签和签名流程检查', '第三方钱包服务商、插件、依赖库风险评估', '按优先级排序的整改清单 + 复盘会'],
      how: [
        { t: '第 1 周', d: '访谈与资产盘点：列出所有能接触到资金的人、设备和系统。' },
        { t: '第 2 周', d: '逐项检查与验证，标出真实可利用的风险。' },
        { t: '第 3 周', d: '交付整改清单，开复盘会，回答团队问题。' },
      ],
      price: { value: '¥3万', unit: '/ 次' },
      faq: [
        { q: '体检和合约审计有什么区别？', a: '合约审计只看链上代码。体检看的是整家公司的资金安全：人、电脑、服务器、钱包、签名流程和第三方工具。近年最大的几起被盗都发生在这些地方。' },
        { q: '需要给你们私钥或服务器权限吗？', a: '不需要私钥。检查以访谈、配置截图和只读权限为主，所有操作都会提前和你确认。' },
        { q: '体检之后一定要买订阅吗？', a: '不需要。整改清单你们可以自己执行；如果需要我们陪同落地，再选订阅或按项目合作。' },
      ],
    },
    en: {
      nav: 'Security Assessment',
      metaTitle: 'Web3 Company Security Assessment — Find Where Your Funds Could Leak | Musesec',
      metaDesc: 'A 2–3 week security assessment for blockchain companies: devices, servers, wallets and signing flows, and third-party dependencies, with a prioritized fix list. From $5k.',
      eyebrow: 'SECURITY ASSESSMENT',
      title: 'In 2–3 weeks, find where your money is most likely to leak',
      sub: 'We review employee devices, servers, wallets and signing flows, and third-party tools, then deliver a prioritized, actionable fix list.',
      who: ['Blockchain startups without a dedicated head of security', 'Teams preparing for launch, fundraising or exchange listing', 'Teams that just had a suspicious incident and want to know what else is exposed'],
      get: ['Interviews with key people: who can move funds, how, and who to call', 'Device, account, server and cloud configuration review', 'Wallet architecture, multisig and signing flow review', 'Risk review of wallet vendors, plugins and dependencies', 'Prioritized fix list + review session'],
      how: [
        { t: 'Week 1', d: 'Interviews and asset inventory: every person, device and system that can touch funds.' },
        { t: 'Week 2', d: 'Item-by-item checks and validation of real, exploitable risks.' },
        { t: 'Week 3', d: 'Fix list delivered, review session, Q&A with your team.' },
      ],
      price: { value: '$5k', unit: '/ project' },
      faq: [
        { q: 'How is this different from a smart contract audit?', a: 'A contract audit reviews on-chain code only. The assessment covers the whole company\'s fund security: people, devices, servers, wallets, signing flows and third-party tools — where the largest recent hacks actually happened.' },
        { q: 'Do you need our private keys or server access?', a: 'Never private keys. The review relies on interviews, configuration evidence and read-only access, and every step is agreed with you in advance.' },
        { q: 'Do we have to buy a subscription afterwards?', a: 'No. You can execute the fix list yourselves; choose a subscription or project only if you want us to help implement.' },
      ],
    },
  },
  {
    slug: 'smart-contract-audit',
    zh: {
      nav: '智能合约审计',
      metaTitle: '智能合约安全审计｜EVM / Solana / Move - 牧色安全',
      metaDesc: '人工 + 自动化工具结合的智能合约安全审计，覆盖 EVM 兼容链、Solana 等公链，交付详细漏洞报告和修复建议，修复后免费复审。',
      eyebrow: '智能合约审计',
      title: '上线前，把合约里的漏洞先找出来',
      sub: '人工逐行审计结合自动化工具，重点看资金流转、权限和业务逻辑，交付能直接照着改的修复建议。',
      who: ['即将上线或升级合约的 DeFi、交易、钱包项目', '需要第三方审计报告用于上所或融资的团队', '合约改动频繁、需要持续复审的团队'],
      get: ['业务逻辑、权限控制、资金流转的人工审计', '自动化工具扫描常见漏洞', '按严重程度分级的漏洞报告与修复建议', '修复后复审', '上线后链上异动监控（可选）'],
      how: [
        { t: '报价', d: '根据代码量和复杂度报价并确认排期。' },
        { t: '审计', d: '人工审计 + 工具扫描，发现严重问题第一时间同步。' },
        { t: '报告与复审', d: '交付报告，修复后复审并更新报告。' },
      ],
      price: null,
      faq: [
        { q: '审计怎么收费？', a: '按代码量和复杂度报价，提交代码仓库或文档后 1 个工作日内给出报价和排期。' },
        { q: '支持哪些链？', a: 'EVM 兼容链（以太坊、BNB Chain、Arbitrum、Base 等）、Solana 以及 Move 系公链。' },
        { q: '审计完就安全了吗？', a: '审计能大幅降低合约风险，但近年多数大额被盗来自链下：签名界面、员工电脑、第三方工具。建议同时做一次资产安全体检。' },
      ],
    },
    en: {
      nav: 'Smart Contract Audit',
      metaTitle: 'Smart Contract Security Audit — EVM, Solana, Move | Musesec',
      metaDesc: 'Manual review plus automated tooling for smart contracts on EVM chains, Solana and Move. Severity-ranked findings, actionable fixes and a free re-audit after remediation.',
      eyebrow: 'SMART CONTRACT AUDIT',
      title: 'Find the bugs before your contracts go live',
      sub: 'Line-by-line manual review plus automated tooling, focused on fund flows, permissions and business logic — with fixes you can apply directly.',
      who: ['DeFi, trading and wallet projects launching or upgrading contracts', 'Teams needing a third-party audit report for listings or fundraising', 'Teams with frequent contract changes that need ongoing re-audits'],
      get: ['Manual review of business logic, access control and fund flows', 'Automated scanning for common vulnerability classes', 'Severity-ranked findings with remediation guidance', 'Re-audit after fixes', 'Optional post-launch on-chain monitoring'],
      how: [
        { t: 'Quote', d: 'Pricing and schedule based on code size and complexity.' },
        { t: 'Audit', d: 'Manual review plus tooling; critical issues are shared immediately.' },
        { t: 'Report & re-audit', d: 'Report delivered, fixes re-audited and the report updated.' },
      ],
      price: null,
      faq: [
        { q: 'How is an audit priced?', a: 'By code size and complexity. Share your repository or docs and we will send a quote and schedule within 1 business day.' },
        { q: 'Which chains do you support?', a: 'EVM chains (Ethereum, BNB Chain, Arbitrum, Base and others), Solana and Move-based chains.' },
        { q: 'Are we safe once audited?', a: 'An audit greatly reduces contract risk, but most large recent losses came from off-chain: signing interfaces, employee devices and third-party tools. We recommend pairing it with a security assessment.' },
      ],
    },
  },
  {
    slug: 'wallet-security',
    zh: {
      nav: '钱包与签名安全',
      metaTitle: '多签 / MPC 钱包与资金架构安全设计 - 牧色安全',
      metaDesc: '为区块链公司设计多签、MPC、冷热钱包分层和审批签名流程，让一个人被骗也转不走钱。¥5 万起。',
      eyebrow: '钱包与签名安全',
      title: '一个人被骗，钱也转不走',
      sub: '设计多签、MPC、冷热钱包分层和审批流程，每次签名前核对交易的真实内容，防范 Bybit 式的签名界面篡改。',
      who: ['用多签或 MPC 管理国库、做市或用户资金的团队', '准备搭建或迁移钱包架构的团队', '签名人分散在多地、靠聊天软件协作签名的团队'],
      get: ['资金流转与权限梳理：谁能动多少钱', '多签 / MPC / 冷热钱包分层方案', '大额转账审批流程与签名前核对清单', '签名设备与环境加固建议', '签名人防钓鱼演练'],
      how: [
        { t: '梳理', d: '画出资金地图：钱在哪、谁有权限、怎么流转。' },
        { t: '设计', d: '给出分层架构、阈值和审批流程方案。' },
        { t: '落地', d: '陪同迁移和第一次大额操作，演练签名核对流程。' },
      ],
      price: { value: '¥5万', unit: '/ 项目' },
      faq: [
        { q: '我们已经用了多签，还需要吗？', a: '多签只解决"需要几个人同意"。如果签名人的电脑或签名界面被控制，几个人都会签下同一笔恶意交易。签名前核对真实内容和设备隔离同样关键。' },
        { q: '会接触我们的私钥吗？', a: '不会。我们只做架构和流程设计，私钥始终由你们的签名人自己保管。' },
        { q: '支持哪些钱包方案？', a: 'Safe 等主流多签、常见 MPC 服务商方案，以及硬件钱包冷存储，按你们的资金规模和团队结构选择。' },
      ],
    },
    en: {
      nav: 'Wallet & Signing Security',
      metaTitle: 'Multisig, MPC & Treasury Security Design for Web3 Teams | Musesec',
      metaDesc: 'Multisig, MPC, hot/cold wallet tiers and approval flows designed so that one compromised person cannot move your funds. From $7k.',
      eyebrow: 'WALLET & SIGNING SECURITY',
      title: 'One phished signer cannot move the funds',
      sub: 'At Bybit, signers approved a different transaction than the one they saw. We design your multisig, MPC, hot/cold wallets and approval flows, and make every signature verifiable before it is signed.',
      who: ['Teams managing treasury, market-making or user funds with multisig or MPC', 'Teams building or migrating their wallet architecture', 'Distributed signers coordinating over chat apps'],
      get: ['Fund flow and permission mapping: who can move how much', 'Multisig / MPC / hot-cold tier design', 'Large-transfer approval flow and pre-signing verification checklist', 'Signing device and environment hardening', 'Anti-phishing drills for signers'],
      how: [
        { t: 'Map', d: 'Draw your fund map: where money sits, who has access, how it moves.' },
        { t: 'Design', d: 'Tiered architecture, thresholds and approval flows.' },
        { t: 'Implement', d: 'Support during migration and the first large operation; drill the verification flow.' },
      ],
      price: { value: '$7k', unit: '/ project' },
      faq: [
        { q: 'We already use a multisig. Do we still need this?', a: 'A multisig only answers "how many people must approve". If signers\' devices or the signing UI are compromised, they will all approve the same malicious transaction. Pre-signing verification and device isolation matter just as much.' },
        { q: 'Will you touch our private keys?', a: 'No. We design architecture and process; keys always stay with your signers.' },
        { q: 'Which wallet setups do you support?', a: 'Mainstream multisigs such as Safe, common MPC providers, and hardware-wallet cold storage — chosen for your fund size and team structure.' },
      ],
    },
  },
  {
    slug: 'incident-response',
    zh: {
      nav: '应急响应',
      metaTitle: '区块链安全事件应急响应｜被盗、被黑后的止损与追踪 - 牧色安全',
      metaDesc: '区块链项目被盗、被入侵后的应急响应：止损、取证、资金追踪、对外沟通与复盘。提供年度应急保留服务，出事 1 小时内接手。',
      eyebrow: '应急响应',
      title: '出事之后的第一个小时最关键',
      sub: '出事后按处置清单执行止损、取证、资金追踪和对外沟通，控制损失扩大。',
      who: ['正在遭受攻击或刚发现资金异常的项目', '希望提前签好应急保留、出事有人接手的团队', '需要事后取证和复盘报告的团队'],
      get: ['7×24 应急联系通道', '止损：暂停合约、冻结账号与密钥、切断入侵路径', '取证与攻击路径还原', '资金流向追踪，协助联系交易所与稳定币发行方', '对外公告建议与事后复盘报告'],
      how: [
        { t: '接手', d: '确认事件范围，给出第一批止损动作。' },
        { t: '处置', d: '切断入侵、保全证据、追踪资金去向。' },
        { t: '复盘', d: '还原攻击路径，交付复盘报告和加固建议。' },
      ],
      price: { value: '¥5万', unit: '/ 年（保留服务）' },
      faq: [
        { q: '没有签保留服务，出事了还能找你们吗？', a: '可以，直接点"正在被攻击？"联系我们。签了保留服务的客户享有优先响应和预先准备好的应急预案。' },
        { q: '你们能把被盗的钱追回来吗？', a: '我们会追踪资金流向，并协助联系交易所、稳定币发行方冻结，但无法承诺追回。任何承诺"保证追回"的机构都要提高警惕。' },
        { q: '出事后第一件事做什么？', a: '暂停可疑合约、冻结相关账号和 API Key；不要关机、不要清理被入侵的电脑；记录可疑交易哈希和时间，然后马上联系我们。' },
      ],
    },
    en: {
      nav: 'Incident Response',
      metaTitle: 'Web3 Incident Response — Containment, Forensics & Fund Tracing | Musesec',
      metaDesc: 'Incident response for hacked blockchain projects: containment, forensics, fund tracing, communications and post-mortem. Annual retainer with a 1-hour takeover target.',
      eyebrow: 'INCIDENT RESPONSE',
      title: 'The first hour after a hack matters most',
      sub: 'We run containment, forensics, fund tracing and communications from a response checklist to limit further losses.',
      who: ['Projects under attack or that just spotted abnormal fund movements', 'Teams wanting a retainer so someone takes over immediately', 'Teams needing forensics and a post-mortem report'],
      get: ['24/7 emergency channel', 'Containment: pause contracts, freeze accounts and keys, cut off the intrusion path', 'Forensics and attack path reconstruction', 'Fund tracing and help contacting exchanges and stablecoin issuers', 'Disclosure guidance and post-mortem report'],
      how: [
        { t: 'Take over', d: 'Scope the incident and give the first containment actions.' },
        { t: 'Respond', d: 'Cut off the intrusion, preserve evidence, trace the funds.' },
        { t: 'Post-mortem', d: 'Reconstruct the attack path and deliver hardening recommendations.' },
      ],
      price: { value: '$7k', unit: '/ year (retainer)' },
      faq: [
        { q: 'Can we contact you without a retainer?', a: 'Yes — click "Under attack?" to reach us. Retainer clients get priority response and a pre-built response plan.' },
        { q: 'Can you recover stolen funds?', a: 'We trace fund flows and help contact exchanges and stablecoin issuers to freeze assets, but we cannot promise recovery. Be wary of anyone who "guarantees" it.' },
        { q: 'What should we do first?', a: 'Pause suspicious contracts, freeze related accounts and API keys, do not shut down or wipe compromised machines, record suspicious transaction hashes and times — then contact us immediately.' },
      ],
    },
  },
]
